export enum EmploymentType {
  Payroll = "Payroll",
  Independent = "Independent",
  UnderVendor = "UnderVendor"
}
